import { useMemo, useContext } from 'react'
import { AppDataContext } from '../providers/AppData'
import useHomePageMeta from './useHomePageMeta'
import getHomeSchema from '../utils/schema/home'

export default function useHomePageSchema() {
  const { locale } = useContext(AppDataContext)
  const homePageMeta = useHomePageMeta()

  return useMemo(() => getHomeSchema({ meta: homePageMeta, locale }), [homePageMeta, locale])
}
